<label class="floating-label" *ngIf="label" for="{{inputId}}">{{ label | translate }}</label>
<input class="input-quantity" type="text" [id]="inputId" [maxlength]="maxLength" [(ngModel)]="value"
       (change)="onChange();" (keydown)="onKeydown($event);" (click)="$event.target.select()"
       [placeholder]="placeholder" />